// extracted by mini-css-extract-plugin
export default {"avatar_wrapper":"AvatarDisplay_avatar_wrapper__qeo6n","edit_img":"AvatarDisplay_edit_img__e6uq1"};